export default function PHP_Namespaces() {
  return (
    <div>
      <h1>PHP_Namespaces</h1>
    </div>
  );
}
